import { useLocation, useNavigate } from "react-router-dom";
import "../css/CustomerSetupMain.css";
import CustomerSetup from "./CustomerSetup";
import InvoiceDetails from "./InvoiceDetails";
import PaymentVoucherTable from "../../credit_invoice/views/PaymentVoucherTable";

const CUSTOMER_SETUP_OPTION = [
  { id: 1, value: "Customer Details", active: "customerdetails" },
  { id: 2, value: "Invoice Details", active: "invoicedetails" },
  { id: 3, value: "Payment Details", active: "paymentdetails" },
];

const CustomerSetupMain = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // Extracting individual query parameters
  const selectedOption = queryParams.get("active");
  const mode = queryParams.get("mode");
  const id = queryParams.get("id");
  const groupId = queryParams.get("group_id");
  const optionId = queryParams.get("option_id");
  const navigate = useNavigate();

  const handleOptionChange = (active) => {
    navigate(
      `/new/setup/customersetup?active=${active}&mode=${mode}${
        mode !== "create" ? `&id=${id}` : ""
      }&group_id=${groupId}&option_id=${optionId}`
    );
  };

  return (
    <div
      className="cu-customer-setup-options-main"
      // style={{
      //   height: selectedOption !== "customerdetails" ? "100vh" : "unset",
      // }}
    >
      <div className="cu-customer-setup-options-menu">
        {CUSTOMER_SETUP_OPTION.map((option) =>
          (option?.value === "Invoice Details" ||
            option?.value === "Payment Details") &&
          mode === "create" ? (
            <></>
          ) : (
            <div
              key={option?.id}
              className={`cu-customer-setup-option ${
                selectedOption === option?.active
                  ? "cu-customer-setup-option-active"
                  : ""
              }`}
              onClick={() => handleOptionChange(option?.active)}
            >
              {option?.value}
            </div>
          )
        )}
      </div>
      {selectedOption === "customerdetails" && (
        <CustomerSetup mode={mode} id={id} />
      )}
      {selectedOption === "invoicedetails" && (
        <InvoiceDetails institutionId={id} />
      )}
      {selectedOption === "paymentdetails" && (
        <PaymentVoucherTable customerId={id} />
      )}
      {/* {isCreate && (
        <SetupForm
          selectedOption={selectedOptionData}
          setIsCreate={setIsCreate}
          setTableData={setTableData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      )} */}
    </div>
  );
};

export default CustomerSetupMain;
